// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"3238":"269d5063","7572":"09f6cf8b","7961":"6e0f2151","8198":"9bb086c3"}[chunkId] + ".css";
};